export const branchCode = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? "IE" : "UK";
// export const branchCode = process.env.REACT_APP_PROJECT_COUNTRY === "ie" ? "TI" : "TU";